import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VTooltip,
    {
      attrs: { "max-width": "500", top: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _vm.avaliando
                ? _c(
                    VChip,
                    {
                      staticClass: "mx-2",
                      attrs: { color: "secondary", outlined: "", small: "" },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "mr-2", attrs: { small: "" } },
                        [_vm._v("wifi_protected_setup")]
                      ),
                      _vm._v(" Avaliando "),
                    ],
                    1
                  )
                : _vm.status
                ? _c(
                    VChip,
                    {
                      staticClass: "mx-2",
                      attrs: { color: "success", outlined: "", small: "" },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "mr-2", attrs: { small: "" } },
                        [_vm._v("check")]
                      ),
                      _vm._v(" Avaliação Finalizada "),
                    ],
                    1
                  )
                : _c(
                    VChip,
                    _vm._g(
                      {
                        staticClass: "mx-2",
                        attrs: { color: "warning", outlined: "", small: "" },
                      },
                      on
                    ),
                    [
                      _c(
                        VIcon,
                        { staticClass: "mr-2", attrs: { small: "" } },
                        [_vm._v("warning")]
                      ),
                      _vm._v(" Avaliação Não Finalizada "),
                    ],
                    1
                  ),
            ]
          },
        },
      ]),
    },
    [
      _c("span", [
        _vm._v(
          "Clique na opção FINALIZAR no final da página para que a avaliação seja válida"
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }